import { Navigate, Outlet } from 'react-router-dom';

import { getHomePathForRole } from '../../utils/authRouting';

/**
 * Garde de portail par rôle (complète ProtectedRoute).
 * @param {string[]} allowedRoles
 * @param {string} [redirectTo] — si absent, redirige vers l’accueil du rôle connecté
 */
export default function RoleRoute({ allowedRoles, redirectTo, userRole }) {
  if (!userRole || !allowedRoles.includes(userRole)) {
    const target = redirectTo ?? getHomePathForRole(userRole);
    return <Navigate to={target} replace />;
  }
  return <Outlet />;
}
